<template>
    <ContainerWithMenu>
        <div class="page-content">
            <div class="row margin-bottom-20">
                <div class="col-xs-7 col-md-7">
                    <ol class="breadcrumb">
                        <li><router-link :to="{name:'calendar'}">Home</router-link></li>
                        <li><router-link :to="{name:'marketing'}">{{$t('views.marketing.title')}}</router-link></li>
                        <li class="active">{{ $t('views.developers.calendar_title') }}</li>
                    </ol>
                </div>
                <div class="col-xs-5 col-md-5 text-right">
                    <button class="btn btn-default" @click="$router.push({name:'marketing'})">
                        <i class="las la-undo"></i>
                        <span class="button-text">{{$t('navigation.back_to_marketing')}}</span>
                    </button>
                </div>
            </div>
            <hr>
            <h1 class="h2">{{ $t('views.developers.calendar_title') }}</h1>
            <p class="margin-bottom-40">{{ $t('views.developers.calendar_content') }}</p>   
            <div class="clearfix margin-bottom-20">
                <div style="background-color:#f5f5f5;float:left;border-radius:6px;padding:12px 18px;">
                    <a :href="calendarLink" target="_blank">{{calendarLink}} <i class="las la-external-link-alt"></i></a>
                </div>
            </div>
            <div
                    v-show="errorMessageCalendarCopy"
                    class="alert alert-danger"
                    role="alert"
            >
                {{ errorMessageCalendarCopy }}
            </div>
            <div
                    v-show="successMessageCalendarCopy"
                    class="alert alert-success"
                    role="alert"
            >
                {{ successMessageCalendarCopy }}
            </div>
            <button class="btn btn-default"
                    v-clipboard="() => calendarLink"
                    v-clipboard:success="successCalendarCopy"
                    v-clipboard:error="errorCalendarCopy">
                <i class="las la-copy"></i>{{ $t('views.developers.calendar_copy_link') }}
            </button>
        </div>
        <SpinnerLoader v-show="loading"></SpinnerLoader>
    </ContainerWithMenu>
</template>

<script>
    import ContainerWithMenu from "../components/container/ContainerWithMenu";
    import SpinnerLoader from "../components/common/SpinnerLoader";
    import {getCompanyInfo} from "../api";
    import {URL_BOOKING} from "../common/constants";
    import i18n from "../i18n";

    export default {
        title: 'Clients Calendar',
        name: "BookingCalendar",
        data: () => {
            return {
                successMessageCalendarCopy: null,
                errorMessageCalendarCopy: null,
                company: {},
                loading: false
            }
        },
        components: { ContainerWithMenu, SpinnerLoader },
        computed: {
            calendarLink() {
              return URL_BOOKING + this.company.username
            }
        },
        methods: {
            successCalendarCopy() {
                this.successMessageCalendarCopy = i18n.t('views.developers.calendar_copy_success');
                this.errorMessageCalendarCopy = '';
            },
            errorCalendarCopy() {
                this.errorMessageCalendarCopy = i18n.t('views.developers.calendar_copy_fail');
                this.successMessageCalendarCopy = '';
            }
        },
        async mounted() {
            this.loading = true;
            this.errorMessage = "";
            try {
                this.company = await getCompanyInfo();
                this.loading = false;
            } catch (e) {
                this.loading = false;

            }
        },

    };
</script>
